import { isAfter } from 'date-fns'

import { UserMessage } from 'utils/models'

/**
 * Whether a message has gone out. A message scheduled for later is not one of
 * the group's messages yet; one whose schedule has passed is - the api hands
 * back the time it went out on `schedule`, so 'has a schedule' and 'is still
 * waiting to be sent' are not the same thing. The rest of the app reads it
 * this way (MessagesFeed, the scheduled-messages count); this is the same test.
 */
export const isSent = (message: UserMessage, now: Date = new Date()): boolean =>
  !message.message.schedule || isAfter(now, new Date(message.message.schedule))

/**
 * The newest sent message of each group, keyed by group id. Groups whose only
 * messages are still waiting to be sent are left out - they have nothing to
 * show yet.
 */
export const pickLatestSentPerGroup = (
  messages: UserMessage[],
  now: Date = new Date(),
): Map<number, UserMessage> => {
  const latest = new Map<number, UserMessage>()
  const latestTime = new Map<number, number>()

  messages.forEach(message => {
    if (!isSent(message, now)) return
    const group = message.message.group
    const time = new Date(message.message.created).getTime()
    const best = latestTime.get(group)
    // '!(best > time)' is what the isAfter comparison came to, an unparseable
    // date included: that compares false, and the current message takes over.
    if (best === undefined || !(best > time)) {
      latest.set(group, message)
      latestTime.set(group, time)
    }
  })

  return latest
}
